module.exports = __webpack_public_path__ + "static/media/insta-lhs.5fbe30b8.jpg";